import {inlineError} from '@s-ui/decorators'

import {SellerRepository} from './SellerRepository.js'

export class EmptySellerRepository extends SellerRepository {
  /**
   * @class
   * @implements SellerRepository
   */
  @inlineError
  async saveContactDetails({adId, message, name, email, phone}) {
    return Promise.resolve()
  }

  @inlineError
  async contactConfiguratorNotLoggedSeller({contactConfiguratorNotLoggedSellerRequest}) {
    return Promise.resolve()
  }
}
